"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.StyledToastifyItemTitle=exports.StyledToastifyItemMessage=exports.StyledToastifyItemContent=exports.StyledToastifyItem=exports.StyledToastifyContainerTopRight=exports.StyledToastifyContainerTopLeft=exports.StyledToastifyContainerTopCenter=exports.StyledToastifyContainerMobileTop=exports.StyledToastifyContainerMobileBottom=exports.StyledToastifyContainerMobile=exports.StyledToastifyContainerBottomRight=exports.StyledToastifyContainerBottomLeft=exports.StyledToastifyContainerBottomCenter=exports.StyledToastifyContainer=exports.StyledToastify=void 0;var _styledComponents=_interopRequireWildcard(require("styled-components"));function _getRequireWildcardCache(e){if("function"!=typeof WeakMap)return null;var r=new WeakMap(),t=new WeakMap();return(_getRequireWildcardCache=function(e){return e?t:r;})(e);}function _interopRequireWildcard(e,r){if(!r&&e&&e.__esModule)return e;if(null===e||"object"!=typeof e&&"function"!=typeof e)return{default:e};var t=_getRequireWildcardCache(r);if(t&&t.has(e))return t.get(e);var n={__proto__:null},a=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var u in e)if("default"!==u&&{}.hasOwnProperty.call(e,u)){var i=a?Object.getOwnPropertyDescriptor(e,u):null;i&&(i.get||i.set)?Object.defineProperty(n,u,i):n[u]=e[u];}return n.default=e,t&&t.set(e,n),n;}const left=(0,_styledComponents.keyframes)`
  0%  {
    opacity: 0;
    right: 300px;
  }
  100% {
    opacity: 1;
    right: 0;
  }
`;const right=(0,_styledComponents.keyframes)`
  0%  {
    opacity: 0;
    left: 300px;
  }
  100% {
    opacity: 1;
    left: 0;
  }
`;const end=(0,_styledComponents.keyframes)`
  0%  {
    opacity: 1;
  }
  100% {
    opacity: 0;
    height: 0;
    margin-bottom: 0;
  }
`;const StyledToastifyItem=exports.StyledToastifyItem=_styledComponents.default.div`
  position: relative;
  width: 280px;
  margin: 0 0 16px;
  top: ${props=>props.top!==null&&`${props.top}px`};
  height: ${props=>props.sHeight!==null?`${props.sHeight}px`:'auto'};

  &.ds-toastify-item-m-left {
    right: 300px;
    animation: ${500}ms ease ${left} forwards;
  }

  &.ds-toastify-item-m-right {
    left: 300px;
    animation: ${500}ms ease ${right} forwards;
  }

  &.ds-toastify-item-s-removing {
    animation: ${500}ms ease ${end} forwards;
  }

  :last-child {
    margin-bottom: 0;
  }
`;const StyledToastify=exports.StyledToastify=_styledComponents.default.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
`;const StyledToastifyContainer=exports.StyledToastifyContainer=_styledComponents.default.div`
  position: fixed;
  z-index: 10001;
`;const StyledToastifyContainerTopCenter=exports.StyledToastifyContainerTopCenter=(0,_styledComponents.default)(StyledToastifyContainer)`
  transform: translateX(-50%);
  top: 16px;
  left: 50%;
`;const StyledToastifyContainerBottomCenter=exports.StyledToastifyContainerBottomCenter=(0,_styledComponents.default)(StyledToastifyContainer)`
  transform: translateX(-50%);
  bottom: 16px;
  left: 50%;
`;const StyledToastifyContainerTopLeft=exports.StyledToastifyContainerTopLeft=(0,_styledComponents.default)(StyledToastifyContainer)`
  top: 16px;
  left: 16px;
`;const StyledToastifyContainerTopRight=exports.StyledToastifyContainerTopRight=(0,_styledComponents.default)(StyledToastifyContainer)`
  top: 16px;
  right: 16px;
`;const StyledToastifyContainerBottomLeft=exports.StyledToastifyContainerBottomLeft=(0,_styledComponents.default)(StyledToastifyContainer)`
  bottom: 16px;
  left: 16px;
`;const StyledToastifyContainerBottomRight=exports.StyledToastifyContainerBottomRight=(0,_styledComponents.default)(StyledToastifyContainer)`
  bottom: 16px;
  right: 16px;
`;const StyledToastifyContainerMobile=exports.StyledToastifyContainerMobile=(0,_styledComponents.default)(StyledToastifyContainer)`
  right: 16px;
  left: 16px;

  ${StyledToastifyItem} {
    max-width: 100%;
    width: 100%;
  }
`;const StyledToastifyContainerMobileTop=exports.StyledToastifyContainerMobileTop=(0,_styledComponents.default)(StyledToastifyContainerMobile)`
  top: 16px;
`;const StyledToastifyContainerMobileBottom=exports.StyledToastifyContainerMobileBottom=(0,_styledComponents.default)(StyledToastifyContainerMobile)`
  bottom: 16px;
`;const StyledToastifyItemContent=exports.StyledToastifyItemContent=_styledComponents.default.div`
  box-sizing: border-box;
`;const StyledToastifyItemTitle=exports.StyledToastifyItemTitle=_styledComponents.default.div`
  box-sizing: border-box;
`;const StyledToastifyItemMessage=exports.StyledToastifyItemMessage=_styledComponents.default.div`
  box-sizing: border-box;
`;